import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PanelModule} from 'primeng/primeng';

import {EmrCasePaperComponent} from './emr-case-paper.component';
import {routing} from './emr-case-paper.routing';
import {SharedTranslationModule} from '../../shared/change-language/shared-translation.module';
import {MstVisitService} from '../../configuration/mst-visit/mst-visit.service';
import {TemrVisitSymptomService} from '../../configuration/temr-visit-symptom/temr-visit-symptom.service';
import {TemrVisitHistoryService} from '../../configuration/temr-visit-history/temr-visit-history.service';
import {TemrVisitChiefComplaintService} from '../../configuration/temr-visit-chief-complaint/temr-visit-chief-complaint.service';
import {TemrVisitNonDrugAllergyService} from '../../configuration/temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.service';
import {TemrVisitAllergyService} from '../../configuration/temr-visit-allergy/temr-visit-allergy.service';
import {TemrDoctorsAdviceService} from '../../configuration/temr-doctors-advice/temr-doctors-advice.service';
import {CpoeInvestigationService} from '../../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-investigation/cpoe-investigation.service';
import {TemrVisitPrescriptionService} from '../../configuration/temr-visit-prescription/temr-visit-prescription.service';
import {TemrVisitDiagnosisService} from '../../configuration/temr-visit-diagnosis/temr-visit-diagnosis.service';
import {TemrTimelineService} from '../../configuration/temr-timeline/temr-timeline.service';
import {TemrVitalService} from '../../configuration/temr-vital/temr-vital.service';
import {CpoeDoctorAdviceService} from '../../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/cpoe-doctoradvice.service';
import {MstUnitService} from '../../configuration/mst-unit/mst-unit.service';
import {EmrPatientListService} from '../emr-patient-list/emr-patient-list.service';
import {TbillRecieptService} from '../../billing/tbill-reciept/tbill-reciept.service';

@NgModule({
  imports: [
    CommonModule, routing, PanelModule, SharedTranslationModule
  ],
  declarations: [EmrCasePaperComponent],

  providers: [MstVisitService,
    TemrVisitHistoryService,
    TemrVisitChiefComplaintService,
    TemrVisitSymptomService,
    TemrVisitNonDrugAllergyService,
    TemrVisitAllergyService,
    TemrDoctorsAdviceService,
    CpoeInvestigationService,
    TemrVisitPrescriptionService,
    TemrVisitDiagnosisService,
    TemrTimelineService,
    TemrVitalService, CpoeDoctorAdviceService,
    MstUnitService, EmrPatientListService, TbillRecieptService]
})
export class EmrCasePaperModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emrsidebar/emr-case-paper/emr-case-paper.module.ts